import { axiosClientPortalInstance } from "./";

const getClientPortalEventsList = (params = {}) =>
  axiosClientPortalInstance.get("/events", { params });

const getClientPortalEvent = (id) =>
  axiosClientPortalInstance.get(`/events/${id}`);

export { getClientPortalEventsList, getClientPortalEvent };
